import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { BrandService } from '../../../../../../services/brand.service';
import { BestService } from '../../../../../../services/best.service';
import { AnalyticsService } from '../../../../../../services/analytics.service';

@Component({
	selector: 'app-best-landing-header',
	templateUrl: './best-landing-header.component.html',
	styleUrls: ['./best-landing-header.component.scss']
})

export class BestLandingHeaderComponent implements OnInit {
	public lenderHeadPhoneStatus: OfficeStatus;
	public siteLogo: boolean = false;
	public recommendedLenderActive: boolean = false;
	public newDesignLoanTypeABTest = false;

	constructor(
		public brandService: BrandService,
		private fruHttp: FruHttpService,
		public best: BestService,
		private route: ActivatedRoute,
		public analyticsService: AnalyticsService
	) {
		/* this prevents the logo from being initially loaded as FRU */
		if(this.route.snapshot.queryParams.l) {
			this.brandService.logoSrc = 'https://s3-us-west-2.amazonaws.com/fru-client-logos/production/300x100/' + this.route.snapshot.queryParams.l + '.png';
		}

		if(this.route.snapshot.queryParams['recommendedLender'] === 'true') {
			this.recommendedLenderActive = true;
		}
	}

	ngOnInit() {
		console.log(this.brandService);
		this.analyticsService.getExperiments().subscribe(
			(variationData: any) => {
				console.log('variation data', variationData.enabledVariations);
					if (variationData.enabledVariations.hasOwnProperty('SiteLogo')) {
						this.siteLogo = true;
					}
					this.newDesignLoanTypeABTest = variationData.enabledVariations.hasOwnProperty('NewDesignLoanTypeV5');
			});
	}

	ngAfterViewInit() {
		if(this.best.lender) {
			this.fruHttp.getLenderPhone(this.best.lender, 'top_10').subscribe(lenderHeadPhoneStatus => this.lenderHeadPhoneStatus = lenderHeadPhoneStatus);
		} else {
			this.route.queryParams.subscribe(params => {
				if (typeof params.l !== 'undefined' && params.l !== '') {
					this.fruHttp.getLenderPhone(params.l, 'top_10').subscribe(lenderHeadPhoneStatus => this.lenderHeadPhoneStatus = lenderHeadPhoneStatus);
				} else {
					this.fruHttp.getLenderPhone('0', 'top_10').subscribe(lenderHeadPhoneStatus => this.lenderHeadPhoneStatus = lenderHeadPhoneStatus);
				}
			});
		}
	}

	adDisclosurePopup() {
		this.fruHttp.adDisclosurePopup();
	}
}
